// نرمال‌سازی متن فارسی — معادل دقیق PersianNormalizer سرور (Phoenix.Localization.Text؛ BR-PAT-020، ADR-015).
// جدول‌ها با کد نقطه یونیکد تعریف شده‌اند تا هیچ نویسه فارسی در کد نباشد (phoenix/no-persian-literals).
import { latinDigits } from './digits';

const ZWNJ = 0x200c;
const TATWEEL = 0x0640;
const PERSIAN_YEH = 0x06cc;
const PERSIAN_KEHEH = 0x06a9;
const HEH = 0x0647;
const ALEF = 0x0627;
const ALEF_MADDA = 0x0622;

/** اعراب، تشدید و علامت‌های کوچک عربی. */
const DIACRITICS = new Set([
  0x064b, 0x064c, 0x064d, 0x064e, 0x064f, 0x0650, 0x0651, 0x0652, 0x0653, 0x0654, 0x0655, 0x0670,
]);

/** نویسه‌های هم‌معنا ← شکل فارسی استاندارد. «آ» فقط در حالت جستجو به «ا» تبدیل می‌شود. */
const CHARACTER_MAP = new Map<number, number>([
  [0x064a, PERSIAN_YEH], // ARABIC YEH
  [0x0649, PERSIAN_YEH], // ALEF MAKSURA
  [0x06d2, PERSIAN_YEH], // YEH BARREE
  [0x0643, PERSIAN_KEHEH], // ARABIC KAF
  [0x06aa, PERSIAN_KEHEH], // SWASH KAF
  [0x0629, HEH], // TEH MARBUTA
  [0x06c0, HEH], // HEH WITH YEH ABOVE
  [0x0623, ALEF], // ALEF WITH HAMZA ABOVE
  [0x0625, ALEF], // ALEF WITH HAMZA BELOW
]);

/** فاصله‌های غیراستاندارد ← فاصله معمولی. */
const UNUSUAL_SPACES = new Set([
  0x00a0, 0x2000, 0x2001, 0x2002, 0x2003, 0x2004, 0x2005, 0x2006, 0x2007, 0x2008, 0x2009, 0x200a, 0x202f,
  0x205f, 0x3000, 0x200b,
]);

function normalize(value: string | null | undefined, forSearch: boolean): string {
  if (!value || value.trim() === '') {
    return '';
  }

  const out: string[] = [];
  let previousWasSpace = false;

  for (const raw of latinDigits(value)) {
    let code = raw.charCodeAt(0);

    if (DIACRITICS.has(code) || code === TATWEEL) {
      continue;
    }
    if (UNUSUAL_SPACES.has(code)) {
      code = 0x20;
    }
    code = CHARACTER_MAP.get(code) ?? code;

    if (code === ZWNJ) {
      if (!forSearch) {
        out.push(String.fromCharCode(ZWNJ));
        previousWasSpace = false;
      }
      continue;
    }

    let character = String.fromCharCode(code);
    if (forSearch) {
      character = code === ALEF_MADDA ? String.fromCharCode(ALEF) : character.toLowerCase();
    }

    if (character === ' ') {
      if (previousWasSpace) {
        continue;
      }
      previousWasSpace = true;
    } else {
      previousWasSpace = false;
    }
    out.push(character);
  }

  return out.join('').trim();
}

/** نرمال‌سازی برای ذخیره: ی/ک/ه، حذف اعراب و کشیده، ارقام لاتین، فشرده‌سازی فاصله؛ نیم‌فاصله حفظ می‌شود. */
export function normalizePersian(value: string | null | undefined): string {
  return normalize(value, false);
}

/** نرمال‌سازی برای جستجو: به‌اضافه حذف نیم‌فاصله، «آ» ← «ا» و کوچک‌سازی لاتین. */
export function normalizePersianForSearch(value: string | null | undefined): string {
  return normalize(value, true);
}
